// Hook useSession — consulta /api/auth/me cacheado.

import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface SessionState {
  isLoading: boolean;
  isAuthenticated: boolean;
  email: string | null;
}

export const useSession = (): SessionState => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["session"],
    queryFn: () => api.auth.me(),
    retry: false,
    staleTime: 5 * 60 * 1000, // 5min
  });

  if (isLoading) return { isLoading: true, isAuthenticated: false, email: null };

  if (isError) {
    // 401 não é "erro" de UX — só falta de sessão
    return { isLoading: false, isAuthenticated: false, email: null };
  }

  return { isLoading: false, isAuthenticated: !!data, email: data?.email ?? null };
};
